export default __webpack_public_path__ + "images/logoAvant.917e1c96302ebbc221f089852eef74b7.svg"